import React from 'react';
import { Chart } from 'react-google-charts';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import {
	LoanSummary,
    getChartQtyForCelestina,
    chartOptionsForCelestina,
    getInnerDisplayFirstRowConfigForCelestina,
	getOuterDisplayConfigForCelestina,
	displayTurnaroundTime,
} from '../cardStatusDisplayConfig';
import Arrow from 'components/elements/Arrow';

type Props = {
	loanSummary: LoanSummary;
	groupSelections: number[];
};

const LoanChartForCelestina = ({ loanSummary, groupSelections }: Props) => {
	const user: {
		branch_name: string;
	} = JSON.parse(localStorage.getItem('tvsd.los.user'));

	return (
		<div>
			<HeaderText>{user?.branch_name} Application Status
			<TurnAroundTimeText>
							Turnaround Time:{" "}
							{loanSummary?.turnaround_time
								? displayTurnaroundTime(loanSummary.turnaround_time)
								: "-"}
						</TurnAroundTimeText>
			</HeaderText>
            <div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					width: '100%',
					marginBottom: '5%',
				}}>
				{getOuterDisplayConfigForCelestina(loanSummary).map((d, idx) => {
					return (
						<StatusContainer key={idx.toString()}>
							<Link
								to={{
									pathname: d.pathname,
									state: {
										applicationstatus: d.applicationstatus,
										groupSelections,
									},
								}}>
								<span style={{ display: 'inline-flex', alignItems: 'center' }}><ApplicationStatus>{d.label} </ApplicationStatus><Arrow border={2} length={7} color='#3548C9'/></span>
								<ApplicationCount>{d.qty}</ApplicationCount>
							</Link>
						</StatusContainer>
					);
				})}
			</div>
			<ChartContainer>
				<div
					className='ChartContainer'
					style={{
						width: '40%',
						marginTop: '-4.5%',
						marginLeft: '-5%',
						border: 'transparent',
					}}>
					<Chart
						chartType='PieChart'
						options={chartOptionsForCelestina}
						data={getChartQtyForCelestina(loanSummary)}
						width={'85%'}
						height={'300px'}
					/>
				</div>
				<ChartHeadingWrapper>
					<ChartHeading>
						{getInnerDisplayFirstRowConfigForCelestina(loanSummary).map((d, idx) => {
							return (
								<Link
									key={idx.toString()}
									to={{
										pathname: d.pathname,
										state: {
											applicationstatus: d.applicationstatus,
											groupSelections,
										},
									}}
									style={{
										textDecoration: 'none',
										width: '33%',
                                        whiteSpace:"nowrap"
									}}>
									<ChatTitle>
											<span style={{ display: 'inline-flex', alignItems: 'center' }}><img src={d.img} alt='refresh' width={17} height={17} /><LabelText>{d.label}</LabelText> <Arrow border={2} length={6} color='#3548C9'/></span> 
										<CountText>{d.qty || 0}</CountText>
									</ChatTitle>
								</Link>
							);
						})}
					</ChartHeading>
				</ChartHeadingWrapper>
			</ChartContainer>
			
		</div>
	);
};

const HeaderText = styled.div`
font-size: 16px;
font-weight: 700;
line-height: 22.4px;
letter-spacing: -0.20000000298023224px;
text-align: left;
color:#253858;
padding:24px 0px;
`;

const LabelText = styled.div`
color: #3548C9;
font-size: 12px;
font-weight: 700;
line-height: 16.8px;
letter-spacing: -0.20000000298023224px;
text-align: left;
text-transform:uppercase;
padding-right:2%;
`

const ChartContainer = styled.div`
	display: flex;
	width: 100%;
	height: 25vh;
	padding: 24px 16px 24px 16px;
	border-radius: 8px;
	background: #ffffff;
	margin-right: 1%;
	margin-top: 1%;
	// background: var(--primary-50-f-2-f-3-ff, #f2f3ff);
	@media only screen and (max-width: 1688px) {
		height: 27vh;
	}
`;

const ChartHeadingWrapper = styled.div`
	width: 60%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

const ChartHeading = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	text-allign: center;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 18px;
`;

const ChatTitle = styled.div`
	display: flex;
	flex-direction: column;
    
`;

const CountText = styled.h3`
color:#395278;
font-family: Inter;
font-size: 36px;
font-weight: 700;
line-height: 50.4px;
text-align: left;

`;

const StatusContainer = styled.div`
	display: flex;
	flex-direction: column;
	text-align: left;
	align-items: flex-start;
	border-radius: 8px;
	background: #ffffff;
	height: 96px;
	padding: 8px 16px;
	width: 23.5%;
	justify-content: center;
`;

const ApplicationStatus = styled.div`
color:#2536B2;
font-size: 12px;
font-weight: 700;
line-height: 16.8px;
letter-spacing: -0.20000000298023224px;
text-align: left;
padding-right:2%;
text-transform:uppercase;
`;

const ApplicationCount = styled.div`
color:#395278;
font-size: 28px;
font-weight: 700;
line-height: 39.2px;
text-align: left;

`;

const TurnAroundTimeText = styled.div`
	font-family: Inter;
	font-size: 12px;
	line-height: 17px;
	text-align: left;
	font-weight: 400;
	margin-top: 5px;
	vertical-align: middle;
	color: #566a89;
	:hover {
		cursor: default;
	}
`;


export default LoanChartForCelestina;
